import {login, logout, getInfo, fromOldFramework, permissions} from '@/api/Login';
import {queryRunAs, queryPrimitiveLoginUser} from '@/api/empower';
import Cookies from 'js-cookie';

const user = {
    state: {
        token: Cookies.get('Admin-Token'),
        roles: [],
        userInfo: {},
        schoolInfo: {},
        permissions: [],
        permissionNameMapping: {},
        departs: [],

        isEmpowerUser: false,
        empowerUserName: ''
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles;
        },
        SET_USERINFO: (state, userInfo) => {
            state.userInfo = userInfo;
        },
        SET_SCHOOLINFO: (state, schoolInfo) => {
            state.schoolInfo = schoolInfo;
        },
        SET_PERMISSIONS: (state, permissionList) => {
            const permissions = [], permissionNameMapping = {};
            permissionList.forEach(item => {
                permissions.push(item.url.trim());
                permissionNameMapping[item.url.trim()] = item.name.trim();
            });
            state.permissions = permissions;
            state.permissionNameMapping = permissionNameMapping;
        },
        SET_DEPARTS: (state, departs) => {
            state.departs = departs;
        },
        SET_isEmpowerUser: (state, isEmpowerUser) => {
            state.isEmpowerUser = isEmpowerUser;
        },
        SET_empowerUserName: (state, empowerUserName) => {
            console.log(empowerUserName)

            state.empowerUserName = empowerUserName;
        }
    },

    actions: {
        // 登录
        Login({commit, dispatch}, userInfo) {
            const account = userInfo.account.trim();
            return new Promise((resolve, reject) => {
                login(account, userInfo.password).then(response => {
                    const data = response.data.data;
                    Cookies.set('Admin-Token', data.token);
                    commit('SET_TOKEN', data.token);
                    commit('SET_USERINFO', data.userPageModel);
                    commit('SET_SCHOOLINFO', data.schoolPageModel);
                    commit('SET_ROLES', data.roleList);
                    commit('SET_DEPARTS', data.departList);
                    dispatch('GetPermission')
                        .then(() => {
                            resolve(response);
                        });
                }).catch(error => {
                    reject(error);
                });
            });
        },
        SetLoginInfo({commit, dispatch}, userInfo) {//设置登录信息，由于当前的登录逻辑中存在多学校和首次登录的验证，登录会被连续调用，故此放在用于完全验证通过后，调用，而store中login，在此不适用
            return new Promise(resolve => {
                const data = userInfo;
                Cookies.set('Admin-Token', data.token);
                commit('SET_TOKEN', data.token);
                commit('SET_USERINFO', data.userPageModel);
                commit('SET_SCHOOLINFO', data.schoolPageModel);
                commit('SET_ROLES', data.roleList);
                commit('SET_DEPARTS', data.departList);
                dispatch('GetPermission')
                    .then(() => {
                        resolve();
                    });
            });
        },
        // 获取用户信息
        GetInfo({commit, state, dispatch}) {
            return new Promise((resolve, reject) => {
                getInfo(Cookies.get('Admin-Token')).then(response => {
                    const data = response.data.data;
                    dispatch('SetInfo', data);
                    dispatch('GetPermission')
                        .then(() => {
                            dispatch('checkEmpower')
                                .then(() => {
                                    resolve(response);
                                })
                        });
                }).catch(error => {
                    reject(error);
                });
            });
        },
        checkEmpower({commit, state}) {
            return new Promise(resolve => {
                queryRunAs()
                    .then(isEmpowerUser => {
                        commit('SET_isEmpowerUser', isEmpowerUser);
                        if(isEmpowerUser) {
                            queryPrimitiveLoginUser()
                                .then(data => {
                                    commit('SET_empowerUserName', data ? data.name : '');
                                    resolve();
                                })
                        } else {
                            resolve()
                        }
                    });
            })
        },
        FromOldFramework({commit, state, dispatch}, userToken) {
            return new Promise((resolve, reject) => {
                fromOldFramework(userToken).then(response => {
                    const data = response.data.data;
                    Cookies.set('Admin-Token', data.token);
                    dispatch('SetInfo', data);
                    dispatch('GetPermission')
                        .then(() => {
                            resolve(response);

                        });
                }).catch(error => {
                    reject(error);
                });
            });
        },
        GetPermission({commit, state, dispatch}) {
            return new Promise((resolve, reject) => {
                permissions().then(response => response.data)
                    .then(data => {
                        commit('SET_PERMISSIONS', data.data);
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        SetInfo({commit, state}, data) {
            commit('SET_TOKEN', Cookies.get('Admin-Token'));
            commit('SET_USERINFO', data.userPageModel);
            commit('SET_SCHOOLINFO', data.schoolPageModel);
            commit('SET_ROLES', data.roleList);
            commit('SET_DEPARTS', data.departList);
        },

        // 登出
        LogOut({commit, state}) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_isEmpowerUser', false);
                    commit('SET_TOKEN', '');
                    commit('SET_ROLES', []);
                    Cookies.remove('Admin-Token');
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            });
        },
    }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js